// Small rose pill that counts failed acceptance cycles on a deliverable
// (rejections or revision-requested rounds). Sits inline alongside the
// status pill in the name-cell sub-line — same visual register as
// SubmissionBadge. Renders nothing when count <= 0 so the absence of
// failures keeps the row visually quiet; the badge only appears once
// there is operational signal worth surfacing. Rose (not red) because
// the failure is recoverable — supplier can resubmit. See brand
// SKILL.md §"Deliverable status pills" and the rose-semantic exception
// for the per-surface reading.

import { clsx } from "clsx";

export interface FailedAcceptanceBadgeProps {
  count: number;
}

const BADGE_CLASS =
  "inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-caption font-medium bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400";

export default function FailedAcceptanceBadge({
  count,
}: FailedAcceptanceBadgeProps) {
  if (count <= 0) return null;
  return (
    <span
      data-testid="failed-acceptance-badge"
      aria-label={`Failed acceptance cycles: ${count}`}
      className={clsx(BADGE_CLASS)}
    >
      ↻ Failed ×{count}
    </span>
  );
}
